import { injectStore } from '@/libs/axios/axiosInterceptos'
import { store } from '@/store/store'
import { Provider } from 'react-redux'

export interface StoreProviderProps {
  children: React.ReactNode
  customStore?: typeof store
}

injectStore(store)

function StoreProvider({ children, customStore }: StoreProviderProps) {
  return <Provider store={customStore ?? store}>{children}</Provider>
}

export default StoreProvider
